<template>
  <div class="screen u-pointer-all">
    <youtube-player
      v-if="idYoutube !== null"
      :id="idYoutube"
      @currentTime="onCurrentTime"
      @play="onPlay"
      @pause="onPause"
    />
    <vimeo-player
      v-else-if="idVimeo !== null"
      :id="idVimeo"
      @currentTime="onCurrentTime"
      @play="onPlay"
      @pause="onPause"
    />
    <vimeo-player
      v-else-if="video !== null"
      @currentTime="onCurrentTime"
      @play="onPlay"
      @pause="onPause"
    />
  </div>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'
import YoutubePlayer from '@/components/common/YoutubePlayer'
import VimeoPlayer from '@/components/common/VimeoPlayer'
import VideoPlayer from '@/components/common/VideoPlayer'

export default {
  mixins: [Object3d],

  components: {
    YoutubePlayer,
    VimeoPlayer,
    VideoPlayer
  },

  props: {
    idYoutube: {
      type: String,
      default: ''
    },
    idVimeo: {
      type: String,
      default: ''
    },
    video: {
      type: String,
      default: ''
    }
  },

  methods: {
    onCurrentTime (value) {
      this.$emit('currentTime', value)
    },
    onPlay () {
      this.$emit('play')
    },
    onPause () {
      this.$emit('pause')
    }
  }
}
</script>

<style lang="stylus">
.screen
  width 1000px
  height 562px
</style>